function activeItensOpacity() {
  let lazyItens = document.querySelectorAll('.lazy-item');
  if (!lazyItens) return;

  setTimeout(() => removeAddClassFromElements(lazyItens, '', 'active'), 100);
}

function changeUrlPageNum() {
  let searchMore = document.querySelector('[data-js="searchMore"]');
  if (!searchMore) return;

  let page = searchMore.getAttribute('data-page');
  if (!page) return;

  let locationHref = window.location.href;
  let newUrl = locationHref.replace(/\/page\/\d+/, `/page/${page}`);

  if (!locationHref.includes('page/') && !locationHref.includes('?s')) {
    return changeUrl(newUrl + `page/${page}/`);
  }

  if (locationHref.includes('?s') && !locationHref.includes('page/')) {
    let replacedSearch = locationHref.replace(/\/\?s\=\w+/, '');
    replacedSearch = replacedSearch.replace(/\/\?search\=\w+/, '');

    newUrl = replacedSearch + `/page/${page}/` + '?' + getUrlVars(locationHref)[0];
  }
  // console.log(locationHref);
  changeUrl(newUrl);
}


function changePageButtonNumber() {
  let blogAction = document.querySelector('.blog-action');
  if (!blogAction) return;

  let dataPage = +blogAction.getAttribute('data-page');
  let maxNumPages = +blogAction.getAttribute('data-maxNumPages');
  if (!dataPage || !maxNumPages) return;

  if (dataPage == maxNumPages) {
    blogAction.remove();
    return;
  }

  blogAction.setAttribute('data-page', dataPage += 1);
}

function blogLoadMore() {
  let searchMore = document.querySelector('[data-js="searchMore"]');
  if (!searchMore) return;

  searchMore.addEventListener('click', (e) => {
    e.preventDefault();

    let nonce = searchMore.getAttribute('data-nonce');
    if (!nonce) { console.error('Form search without nonce'); return; }

    let page = searchMore.getAttribute('data-page');
    let search = searchMore.getAttribute('data-search');
    let category = searchMore.getAttribute('data-category');
    let tagId = searchMore.getAttribute('data-tagId');
    let postsPerPage = searchMore.getAttribute('data-posts-per-page');
    let postsFeatureCrop = searchMore.getAttribute('data-posts-Feature-crop');

    let objData = {
      nonce,
      page,
    };

    if (category) objData = { ...objData, category };

    if (tagId) objData = { ...objData, tagId };

    if (search) objData = { ...objData, search: search };

    if (postsPerPage) objData = { ...objData, postsPerPage: postsPerPage };

    if (postsFeatureCrop) objData = { ...objData, postsFeatureCrop: postsFeatureCrop };

    searchPosts(objData)
  });
}

blogLoadMore();

function searchPosts(dataSubmit) {
  let dataBaseUrl = $('footer').attr('data-base-url');
  if (!dataBaseUrl) { console.error('data-base-url is not defined'); return; }

  let postContainer =
    document.querySelector('[data-js="posts-container"]');

  if (postContainer) {
    let dataPostContainerClass = postContainer.getAttribute('data-postContainerClass');

    if (dataPostContainerClass) dataSubmit = { ...dataSubmit, postContainerClass: dataPostContainerClass };
  }

  let $editorialAction = $('.editorial-action');
  let editorialLoadingText = $editorialAction.attr('data-loading-text');
  let editorialTextAfterLoading = $editorialAction.attr('data-textAfterLoading');

  $.ajax({
    type: "POST",
    url: `${dataBaseUrl}/wp-admin/admin-ajax.php?action=search_posts`,
    data: dataSubmit,
    beforeSend: function (xhr, opts) {
      $editorialAction.text(editorialLoadingText);
    },
    complete: function () {
      $editorialAction.text(editorialTextAfterLoading);
    },
    success: function (data, textStatus) {
      // console.log(data);
      $('[data-js="posts-container"]').append(data);

      changeUrlPageNum();

      changePageButtonNumber();

      activeItensOpacity();
    },
    error: function (xhr, er) {
      let $errorContainer = $('.error-container');
      if ($errorContainer) $errorContainer.addClass('active');
      $editorialAction.remove();

      console.log('Error ' + xhr.status + ' - ' + xhr.statusText + '\nTipo de erro: ' + er);
    }
  });
}